// extracted by mini-css-extract-plugin
module.exports = {"editor":"koagxO","editor__content":"xWhOMK","editor__tabs":"bnvelb"};